<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Un-Delivered Shipment Status Report</strong>       
          </div>
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" > 
                  <b-form-group label="Date"  :label-cols="3" >
                    <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                    </v-date-picker>                    
                  </b-form-group>
                </b-col>
                <b-col md="6" > 
                <b-button type="submit" size="md" variant="primary" @click="displaydata">Submit</b-button>
                 </b-col>
              </b-row>  
            </form>
          </div>
          <div class="table-responsive" id="searchlisting">
            <table class="table table-striped table-bordered" border="1">
              <thead>
                <tr>
                  <th>Shipping ID</th>
                  <th>Shipment Status</th>
                  <th>Ship Location Id</th>
                  <th>delivery status</th>
                  <th>pickup location address</th>
                </tr>
              </thead>
              <tbody>
               <template v-for="(value, firstIndex) in data">
                <tr>
                    <td>
                      <span v-on:click="shippingLogDetails(value.shippingid)" class="button is-small is-info shipbtn" style="padding:10px;height:35px;font-size:15px;margin-top:-3px;background:transparent;color:#000;margin-right:10px">{{ value.shippingid }} </span>
                    </td>
                    <td>{{ value.shipmentstatus }} </td>
                    <td>{{ value.shippincode }}</td>
                    <td>{{ value.deliverystatus }}</td>
                    <td>{{ value.pickuplocationaddress }}</td>
                </tr>
                <tr id="shipmentLogs">
                  <td colspan="5">
                      <div v-bind:id="value.shippingid" style="display:none" class="shipmentlogstyle table-responsive">
                        <table class="table table-striped table-bordered">
                          <thead>
                            <tr v-if="isConsignmentActivityTrackingGetWeb !== 0">
                              <th>Shipment Id</th>
                              <th>Pickup Location Name </th>
                              <th>Process</th>
                              <th>Comments </th>
                              <th>Created By </th>
                              <th>Created Date </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="value in logdata">
                              <td>{{ value.shippingid }}</td>
                              <td>{{ value.pickuplocationname }}</td>
                              <td>{{ value.process }}</td>
                              <td>{{ value.comments }}</td>
                              <!-- <td>{{ value.lastprocess }}</td> -->
                              <!-- <td>{{ value.lastcomments }}</td> -->
                              <td>{{ value.createdby }}</td>
                              <td style="width: 100px;">{{ value.createddate | datechange}}</td>
                            </tr>
                            <tr v-if="data.length === 0 && isConsignmentActivityTrackingGetWeb !== 0">
                              <td colspan="7"style="padding-left: 500px;"> <font color="red">No Result Found</font></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
    </b-row>      
</div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      name: 'undeliveredshipmentstatus',
      data: [],
      customer: {},
      seen: true,
      showhtml : true,
      isConsignmentActivityTrackingGetWeb: 0,
      logdata:[],
      selectedDate: new Date(),
    }
  },
  created: function() {
    this.displaydata()
  },
  methods: {
    validateForm(scope) {},
    displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var pincode=userInfo.pickuplocationpincode;
      var fromdate = this.formatDate(this.selectedDate);
      var shipments={
        pickuplocationpincode:pincode.toString(),
        fromdate: `${fromdate}`
      }
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster/GetAllRTOshipments`,shipments)
        .then(result => {
        if((result.body[0].returnmsg && result.body[0].returnmsg === 'UnSuccessful') ||result.body[0].returnmsg === 'No Records Found'
          ) {
            this.data = '';
            alert('Result not found')
          } else {
            this.data = result.body
          }
        })
        .catch(ex => {
          console.log('error', ex)
        })
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    shippingLogDetails:function(val){

      var x = document.getElementById(val);
        if (x.style.display === "none") {
          let shitags = document.getElementsByClassName('shipmentlogstyle');
          for(i=0;i<shitags.length;i++){
            shitags[i].style.display = 'none';
          }
          
          x.style.display = "block";
          var searchvaluesarr = []
          var shipmentid = val
          var searchvalues = shipmentid.split(',')
          for (var i = 0; i < searchvalues.length; i++) {
            searchvaluesarr.push(`${searchvalues[i]}`)
          }
          const customerGetAllobj = {
            shippingid: searchvaluesarr
          }
          this.$http.post(`${CONSTANTS.API_URL}/fastBees/ConsignmentActivityTrackingGetWeb`, customerGetAllobj)
            .then((result) => {
              if (result.body.returnmsg && result.body.returnmsg === 'UnSuccessful') {
                this.logdata = []
                //Utils.notify('Result not found', 'error')
                this.isConsignmentActivityTrackingGetWeb = 1
                var searchlisting = document.getElementById(val)
                searchlisting.style.display = 'block'
              } else if (result.body.length === 0) {
                //Utils.notify('Result not found', 'error')
                this.logdata = []
                this.isConsignmentActivityTrackingGetWeb = 1
                var searchlisting = document.getElementById(val)
                searchlisting.style.display = 'block'
              } else {
                this.logdata = result.body
                this.isConsignmentActivityTrackingGetWeb = 1
                var searchlisting = document.getElementById(val)
                searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
        } else {
            //document.getElementById('shipmentLogs').style.display = "none";
            x.style.display = "none";
        }
    }
  },
  filters: {
    datechange: function(value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
}
</script>
